import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ParticipationHelpModalComponent } from "../participation-help-modal/participation-help-modal.component";

@Component({
  selector: 'app-participation-help',
  templateUrl: './participation-help.component.pug',
  styleUrls: ['./participation-help.component.scss'],
  standalone: false
})
export class ParticipationHelpComponent implements OnInit {
  @Input() request;
  bsModalRef!: BsModalRef;

  constructor(private modalService: BsModalService,) {
  }

  ngOnInit(): void {
  }

  showHelp(): void {
    let initialState = { 'request': this.request };
    if (this.request == 'exit') {
      this.bsModalRef = this.modalService.show(ParticipationHelpModalComponent, {
        class: 'modal-dialog-centered modal-lg', initialState
      });
    }
    else if (this.request == 'pulse') {
      this.bsModalRef = this.modalService.show(ParticipationHelpModalComponent, {
        class: 'modal-centered max-width-552 max-height-430', initialState
      });
    }
  }


}
